import { Link, NavLink, Outlet } from "react-router-dom";
import Button from "../../components/ui/Button";
import StrokeTitle from "../../components/ui/StrokeTitle";
import { useState } from "react";
import Modal from "../../components/ui/Modal";
import AltTitle from "../../components/ui/AltTitle";

const LevelSystem = () => {
  return (
    <>
      <div className="text-wrapper">
        <div className="page-nav">
          <NavLink to="characters">
            <Button text="Leveling Characters" color="blue"/>
          </NavLink>
          <NavLink to="reincarnation">
            <Button text="Reincarnation System" color="blue"/>
          </NavLink>
          <NavLink to="item-reincarnation">
            <Button text="Item Reincarnation" color="blue"/>
          </NavLink>
          <NavLink to="basic">
            <Button text="Basic Systems" color="blue"/>
          </NavLink>
          <NavLink to="character-features">
            <Button text="Character Features" color="blue"/>
          </NavLink>
          <NavLink to="netherworld">
            <Button text="Netherworld Sightseeing" color="blue"/>
          </NavLink>
        </div>
      </div>
      <Outlet/>
      <div className="text-wrapper">
        <div className="page-nav">
          <NavLink to="characters">
            <Button text="Leveling Characters" color="blue"/>
          </NavLink>
          <NavLink to="reincarnation">
            <Button text="Reincarnation System" color="blue"/>
          </NavLink>
          <NavLink to="item-reincarnation">
            <Button text="Item Reincarnation" color="blue"/>
          </NavLink>
          <NavLink to="basic">
            <Button text="Basic Systems" color="blue"/>
          </NavLink>
          <NavLink to="character-features">
            <Button text="Character Features" color="blue"/>
          </NavLink>
          <NavLink to="netherworld">
            <Button text="Netherworld Sightseeing" color="blue"/>
          </NavLink>
        </div>
      </div>
    </>
  )
}

const Leveling = () => {

  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 11
  })

  return (
    <>
      <Modal modal={modal} setModal={setModal} url="level_.png"/>
      <StrokeTitle text="Use the Most Characters in a Disgaea Title Ever to Create Your Dream Party!"/>
      <div className="text-wrapper">
        <p className="white-text">
          Disgaea 7 Complete's generic characters include everything from cool warriors to cute witches and crusty zombies for an all-time high of 45 character classes! Create your very own band of bad guys from this highly colorful rogues' gallery!
        </p>
      </div>
      <img className="large-ss ss-system" style={{marginBottom: '50px '}} src={`${process.env.PUBLIC_URL}/img/ss/level_1.png`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 1,
            }
          )
      }}/>

      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/level_2.png`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 2,
                }
              )
          }}/>
          <h3 className="item-text white-text">
            Professor: Boosts Allies in Many Ways
          </h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/level_3.png`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 3,
                }
              )
          }}/>
          <h3 className="item-text white-text">
            Thief: Steals Items from Enemies
          </h3>
        </div>
      </div>

      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/level_4.png`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 4,
                }
              )
          }}/>
          <h3 className="item-text white-text">
          Gunner: Firearm Specialist
          </h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/level_5.png`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 5,
                }
              )
          }}/>
          <h3 className="item-text white-text">
          Psychic: Uses Superspeed and Psychokinesis
          </h3>
        </div>
      </div>

      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/level_6.png`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 6,
                }
              )
          }}/>
          <h3 className="item-text white-text">
            Prinny: What's a Party Without the Weakest Mascot Ever!?
          </h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/level_7.png`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 7,
                }
              )
          }}/>
          <h3 className="item-text white-text">
            Disgaea 7 Complete introduces many new characters, too!
          </h3>
        </div>
      </div>
      <StrokeTitle text="Disgaea Means Making the Party YOU Want!"/>
      <div className="text-wrapper">
        <p className="white-text">
          Disgaea is filled with characters--picking a party concept will give you all sorts of options!

          Will you make an all-girl party? A Hinomoto-style party? A party of puny Prinnies? Or perhaps a party centered around one insanely powerful character!

          Sticking to a theme for your party will make playing Disgaea even more fun!
        </p>
      </div>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/level_8.png`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 8,
                }
              )
          }}/>
          <h3 className="item-text white-text">
            Magic, combat, healing--in Disgaea, female(?) characters can do it all!
          </h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/level_9.png`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 9,
                }
              )
          }}/>
          <h3 className="item-text white-text">
            Create a Hinomoto-themed party full of ninja and samurai characters!
          </h3>
        </div>
      </div>   
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/level_10.png`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 10,
                }
              )
          }}/>
          <h3 className="item-text white-text">
            Turn the tables and train your pathetic Prinnies to become perilous punch-packers! Who's the puny one now!?
          </h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/level_11.png`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 11,
                }
              )
          }}/>
          <h3 className="item-text white-text">
            With proper training, a single lone wolf character can carry you to victory!
          </h3>
        </div>
      </div>   
    </>
  )
}

const Reincarnation = () => {

  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 3
  })

  return (
    <>
      <Modal modal={modal} setModal={setModal} url="rein_.png"/>
      <StrokeTitle text="Keep Reincarnating to Become the Very Evilest You Can Be!"/>
      <div className="text-wrapper">
        <p className="white-text">
          Reincarnation lets characters be reborn as a different class. The character's level returns to 1 after reincarnating, but you keep some stats and abilities, becoming even stronger than before! Keep reincarnating to master both physical and magical attacks, creating your very own ultimate badass!
        </p>
      </div>
      <div className="item">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rein_1.png`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 1,
            }
          )
        }}/>
        <h3 className="item-text white-text">
          Reincarnate a Warrior into a Magician, and now you have a battlemage! An ex-Warrior Magician will excel at close combat!
        </h3>
      </div>
      <StrokeTitle text="All You Need is Love...and Reincarnation!"/>
      <div className="text-wrapper">
        <p className="white-text">
          Even if a character you like has weak stats and adds nothing to the team, don't give up on them! Keep reincarnating, and eventually you'll get a character with useful stats.

          Anything goes in Disgaea, so if you love a character, you will be able to make them succeed. Forget about the theory--pick whoever you like, and play Disgaea your way!
        </p>
      </div>
      <div className="pair">
      <div className="item">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rein_2.png`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 2,
            }
          )
        }}/>
        <h3 className="item-text white-text">
          This guy started out as a rookie...
        </h3>
      </div>
      <div className="item">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rein_3.png`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 3,
            }
          )
        }}/>
        <h3 className="item-text white-text">
          But now he's a fearsome Magician and his stats have shot way up!
        </h3>
      </div>
      </div>
    </>
  )
}

const ItemReincarnation = () => {
  
  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 2
  })

  return (
    <>
      <Modal modal={modal} setModal={setModal} url="item_.png"/>
      <StrokeTitle text="From a Stick of Gum to a Legendary Sword!"/>
      <div className="text-wrapper">
        <p className="white-text">
          Item Reincarnation is a new system for reincarnating items into powerful treasures! The item's previous characteristics are preserved, so a healing item that is crafted into a sword will still be edible, and a staff made from slippers will still increase movement when equipped. The sky's the limit with this topsy-turvy system!

          <br/>

          What fiendish items will you create, and who will wield them? You decide!
        </p>
      </div>
      <div className="pair">
      <div className="item">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/item_1.png`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 1,
            }
          )
        }}/>
        <h3 className="item-text white-text">
          There are only a few specials at first...
        </h3>
      </div>
      <div className="item">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/item_2.png`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 2,
            }
          )
        }}/>
        <h3 className="item-text white-text">
          But keep reincarnating and you'll have more than you know what to do with!
        </h3>
      </div>
      </div>
      <StrokeTitle text="Repeatedly Reincarnate to Forge the Ultimate Weapon!"/>
      <div className="text-wrapper">
        <p className="white-text">
        OVERVIEW <br/>
        What is Item Reincarnation?
        </p>
        <p className="white-text" style={{marginTop: '25px'}}>
          1st Gen <br/>
          You want to make an ordinary pair of glasses...
          improve your MOVE!
          So you reincarnate them into shoes!
        </p>
        <p className="white-text"  style={{marginTop: '25px'}}>
          2nd Gen
          Now you have shoes that improve HIT!
          But you want a powerful weapon...
          So you reincarnate them into a spear!
        </p>
        <p className="white-text"  style={{marginTop: '25px'}}>
          3rd Gen
          A spear that improves MOVE and HIT!
        </p>
        <p className="white-text"  style={{marginTop: '25px'}}>
          4th Gen
          Continue reincarnating and...
        </p>
        <p className="white-text"  style={{marginTop: '25px'}}>
          You end up with a sword that improves MOVE, HIT, and can use spear specials!
        </p>
      </div>
      <Link to="../basic">
        <Button text="Item Worlds" color="blue"/>
      </Link>
    </>
  )
}

const LevelBasic = () => {
  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 5
  })

  return (
    <>
      <Modal modal={modal} setModal={setModal} url="lb_.jpg"/>
      <StrokeTitle text="An Amulet Made from Borrowed Muscles? Disgaea's Items Truly are Wacky"/>
      <div className="text-wrapper">
        <p className="white-text">
          There is so much more to equip than just weapons. All types of equipment have their own properties, which can be massively improved in their own unique ways! 

          Adjust equipment to match the character. Can't take a punch? Add some Muscles to boost your HP! Can't get where you're going? Equip Shoes to go the distance!
        </p>
      </div>
      <div className="text-wrapper">
        <p className="white-text">
          OVERVIEW <br/>
          Nowhere is off-limits! The battlefield is yours to command!
        </p>
        <p className="white-text" style={{marginTop: '25px'}}>
          This thief can only move 6 panels at first.
          But load her up with shoes and...
        </p>
        <p className="white-text"  style={{marginTop: '25px'}}>
          2nd Gen
          Now you have shoes that improve HIT!
          But you want a powerful weapon...
          So you reincarnate them into a spear!
        </p>
        <p className="white-text"  style={{marginTop: '25px'}}>
          Her MOVE increases, giving her free reign to maneuver!
        </p>
        <p className="white-text"  style={{marginTop: '25px'}}>
          Equip Shoes to boost movement and jumping abilities. No part of the battlefield is off limits now!
        </p>
      </div>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/lb_1.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 1,
              }
            )
          }}/>
          <h3 className="item-text white-text">
            Characters can equip up to 3 non-weapon items.
          </h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/lb_2.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 2,
              }
            )
          }}/>
          <h3 className="item-text white-text">
            Equip Muscles to increase your HP and toughness. Wimpy attacks won't even scratch these buffed-up muscles!
          </h3>
        </div>
      </div>
      <StrokeTitle text="Conquer Item Worlds to Strengthen Items!"/>
      <div className="text-wrapper">
        <p className="white-text">
          Each item has its own Item World, which must be cleared to improve that item! Conquer the random dungeons sprawling inside an item to enhance its stats. <br/>

          The rarer the item, the tougher the dungeon, so explore the dungeons of rare items at your own peril... Battles here are not your usual fare, but emerge victorious and watch your items improve!
        </p>
      </div>
      <div className="item">
        <img className="large-ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/lb_3.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 3,
              }
            )
          }}/>
          <h3 className="item-text white-text">
            "Innocents" are peculiar inhabitants of Item Worlds. Defeat these locals and clear the stage to further improve your items!
          </h3>
      </div>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/lb_4.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 4,
              }
            )
          }}/>
          <h3 className="item-text white-text">
            Rare items house powerful enemies... If you plunge in heedlessly, you're in for a nasty surprise!
          </h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/lb_5.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 5,
              }
            )
          }}/>
          <h3 className="item-text white-text">
            You may encounter Mystery Rooms in an Item World. Ultra-rare items may await inside!
          </h3>
        </div>
      </div>
    </>
  )
}

const CharacterFeatures = () => {
  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 5
  })

  return (
    <>
      <Modal modal={modal} setModal={setModal} url="ct_.png"/>
      <StrokeTitle text="What Features Make Up a Character?"/>
      <img className="large-ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/ct_1.png`} alt="Top-SS" onClick={()=>{
        setModal(
          {
            ...modal,
            'visible': true,
            'current': 1,
          }
        )
      }}/>
      <div className="text-wrapper">
        <p className="white-text">
          Characters may specialize in areas, such as physical attacks, magical attacks, or support. Focus on a character's strengths as you work to level them up!
        </p>
      </div>
      <StrokeTitle text="Evilities and Jumbilities"/>
      <div className="text-wrapper">
        <AltTitle text="What are Evilities?"/>
        <img className="large-ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/ct_2.png`} alt="Top-SS" onClick={()=>{
        setModal(
          {
            ...modal,
            'visible': true,
            'current': 2,
          }
        )
      }}/>
        <p className="white-text">
          Special abilities possessed by characters. Characters have Unique Evilities that only they can use, but they can also can access various Common Evilities, for a price.
        </p>
        <AltTitle text="What are Jumbilities?"/>
        <img className="large-ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/ct_3.png`} alt="Top-SS" onClick={()=>{
        setModal(
          {
            ...modal,
            'visible': true,
            'current': 3,
          }
        )
      }}/>
        <p className="white-text">
          These unique abilities activate during Jumbification. Enemies and allies alike are affected by Jumbilities, as they affect the entire map.
        </p>
      </div>
    </>
  )
}

const NetherworldSightseeing = () => {
  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 18
  })

  return (
    <>
      <Modal modal={modal} setModal={setModal} url="sight_.png"/>
      <StrokeTitle text="Netherworld Sightseeing"/>
      <div className="text-wrapper">
        <p className="white-text">
          Hinomoto's unique culture and landmarks have made the region a tourist destination. Take a trip and see for yourself! Discover special conversations that flesh out the story, play minigames, and get the full Disgaea 7 Complete experience!
        </p>
      </div>
      <div className="item">
        <img className="large-ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_1.png`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 1,
            }
          )
        }}/>
        <h3 className="item-text white-text">
          Just like the story, talk to the Dimension Guide to set out on your adventures!
        </h3>
      </div>
      <StrokeTitle text="Special Dialogue"/>
      <div className="pair">
      <div className="item">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_2.png`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 2,
            }
          )
        }}/>
      </div>
      <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_3.png`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 3,
            }
          )
        }}/>
      </div>
      <div className="text-wrapper">
        <p className="white-text">
          People are beginning their lives again as peace returns to Hinomoto. Chat with the locals to learn about their diverse stories!
        </p>
      </div>
      <StrokeTitle text="Extra Color Palette Characters"/>
      <div className="item">
        <img className="large-ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_4.png`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 4,
            }
          )
        }}/>
      </div>
      <div className="text-wrapper">
        <p className="white-text">
          You may even meet characters with different color palettes than usual. Defeat them, and they will join your party!
        </p>
      </div>
      <StrokeTitle text="Special Quests"/>
      <div className="item">
        <img className="large-ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_5.png`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 5,
            }
          )
        }}/>
      </div>
      <div className="text-wrapper">
        <p className="white-text">
        You may encounter special requests on your journey. Fulfill these requests to receive a reward--you don't want to turn these jobs down!
        </p>
      </div>
      <div className="pair">
      <div className="item">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_6.png`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 6,
            }
          )
        }}/>
        <h3 className="item-text white-text">
          Requests may hint at a character's nature, too.
        </h3>
      </div>
      <div className="item">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_7.png`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 7,
            }
          )
        }}/>
        <h3 className="item-text white-text">
          Clear these quests to get a heartfelt reward! (The heartfeltness may vary)
        </h3>
      </div>
    </div>
    <StrokeTitle text="The General Store & Treasure Chests" />
      <div className="item">
        <img className="large-ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_8.png`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 8,
            }
          )
        }}/>
        <h3 className="item-text white-text">
          A General Store may also open in Netherworlds that have become peaceful! Local products and great bargains await!
        </h3>
      </div>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_9.png`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 9,
              }
            )
          }}/>
          <h3 className="item-text white-text">
            Netherworld-specific items, which are not normally sold in shops, may be available here.
          </h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_10.png`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 10,
              }
            )
          }}/>
          <h3 className="item-text white-text">
            Don't forget to snap up any Treasure Chests you see lying around!
          </h3>
        </div>
      </div>
      <StrokeTitle text="Hinomoto Minigames"/>
      <div className="text-wrapper">
        <p className="white-text">
          Special Netherworlds also offer minigames! Demon Shogi involves beating a stage as quickly as possible using AI, or you can test your strength in the Hinomoto Martial Arts Tournament.

          These games can be played as many times as you like--perfect for when you need a break from saving the world.
        </p>
      </div>
      <StrokeTitle text="Demon Shogi"/>
      <img className="large-ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_11.png`} alt="Top-SS" onClick={()=>{
        setModal(
          {
            ...modal,
            'visible': true,
            'current': 11,
          }
        )
      }}/>
      <div className="text-wrapper">
        <p className="white-text">  
          Demon Shogi is a minigame using Demonic Intelligence ("D.I."), the game's combat AI. Edit your allied characters' D.I. to win in as few turns as possible! You can get all sorts of prizes, depending on how many turns you take!
        </p>
      </div>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_12.png`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 12,
              }
            )
          }}/>
          <h3 className="item-text white-text">
            Defeating that Prinny in the distance requires using an old, familiar system...?
          </h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_13.png`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 13,
              }
            )
          }}/>
          <h3 className="item-text white-text">
            The higher the difficulty, the more advanced your D.I. will have to be. You'll be a D.I. master by the time you can clear any board!
          </h3>
        </div>
      </div>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_14.png`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 14,
              }
            )
          }}/>
          <h3 className="item-text white-text">
            When issues arise, you can adjust things quickly. There is no penalty for this, so try it out!
          </h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_15.png`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 15,
              }
            )
          }}/>
          <h3 className="item-text white-text">
            There are many ways to be the fastest. Keep replaying to reach new speeds!
          </h3>
        </div>
      </div>
      <StrokeTitle text="Hinomoto Martial Arts Tournament"/>
      <div className="item">
          <img className="large-ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_16.png`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 16,
              }
            )
          }}/>
        </div>
      <div className="text-wrapper">
        <p className="white-text">
          The Hinomoto Martial Arts Tournament consists of 8 teams. Being the strongest means never backing down. Beat tough opponents to rise to the top! Amazing prizes await the victor!
        </p>
      </div>
      <div className="pair">
      <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_17.png`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 17,
              }
            )
          }}/>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_18.png`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 18,
              }
            )
          }}/>
        </div>
      </div>
    </>
  )
}

export default LevelSystem;
export {
  Leveling, Reincarnation, ItemReincarnation, LevelBasic, CharacterFeatures, NetherworldSightseeing
};